import { render, staticRenderFns } from "./LoadingBlock.vue?vue&type=template&id=93dd75a0&scoped=true&"
import script from "./LoadingBlock.vue?vue&type=script&lang=ts&"
export * from "./LoadingBlock.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingBlock.vue?vue&type=style&index=0&id=93dd75a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dd75a0",
  null
  
)

export default component.exports